import React, { useState, FC } from 'react';
import { BreakpointsInPx } from '../../../../constants/breakpoints.constants';
import useMediaQuery from '../../../../hooks/useMediaQuery';
import { InteractiveImageModel } from '../../models/interactiveImage.model';
import { InteractiveImageMblDeskItemFieldItemField, InteractiveImageProps } from '../../types/interactiveImage.types';
import './styles.scss';
import ModalDialog from '../../../@shared/modalDialog';
import Picture from '../../../@shared/picture';
import useSitecoreContext from '../../../../hooks/useSitecoreContext';
import SplitModuleContainer from '../../../@shared/splitModuleContainer';
import { SplitModuleContainerProps } from '../../../@shared/splitModuleContainer/types/splitModuleContainer.types';

const InteractiveImageHotspot: FC<InteractiveImageProps & { isEE: boolean }> = (props) => {
  const model = new InteractiveImageModel(props);
  const isWide = useMediaQuery(`(min-width: ${BreakpointsInPx['tbl-p']})`);
  const { hotspotImage, items: hotspotData } = model.mblDeskItem(isWide);
  const [isPopUpOpen, setIsPopUpOpen] = useState(false);
  const [selectedPopUpData, setSelectedPopUpData] = useState<InteractiveImageMblDeskItemFieldItemField | undefined>({});
  const {sitecoreContext} = useSitecoreContext();

  const splitModuleData: SplitModuleContainerProps = {
    fields: {
      title: selectedPopUpData?.title,
      bodyText: selectedPopUpData?.description,
      items: selectedPopUpData?.items?.map((eachMediaItem, index) => ({
        fields: {
          image: eachMediaItem.fields?.image,
          useVideo: eachMediaItem.fields?.useVideo,
          video: eachMediaItem.fields?.video,
          mobileImage: eachMediaItem.fields?.mobile,
        },
        id: index.toString(),
      })),
      link1: selectedPopUpData?.link1,
      link2: selectedPopUpData?.link2,
    },
    params: {
      imagePosition: selectedPopUpData?.imagePosition?.value || 'left',
    },
  };

  const closePopup = (): void => setIsPopUpOpen(false);

  const handleHotspotClick = (fields: InteractiveImageMblDeskItemFieldItemField | undefined): void => {
    setSelectedPopUpData(fields);
    setIsPopUpOpen(true);
  };

  return (
    <div className="interactive-image__picture-wrapper">
      <Picture
        editorialImageProps={{
          desktopImage: hotspotImage,
          desktopTransformation: 'Size1100',
          mobileTransformation: 'Size500',
          cssClassPictureEl: 'interactive-image__picture',
        }}
      />
      {hotspotData?.map(({ fields }) => {
        const { coordinates } = fields || {};
        const [top, left] = coordinates?.value?.split(',').map((_) => _ + '%') || [];
        return (
          <div
            key={`${left}-${top}`}
            style={{ left, top }}
            onClick={(): void => handleHotspotClick(fields)}
            className="interactive-image__hotspot-item"
          ></div>
        );
      })}
      <ModalDialog isOpen={isPopUpOpen} close={closePopup} className="hotspot-dialog-box">
        <>
          <div className="hotspot-split-module-wrapper">
            <SplitModuleContainer {...splitModuleData} sitecoreContext={sitecoreContext} />
          </div>
        </>
      </ModalDialog>
    </div>
  );
};

export default InteractiveImageHotspot;
